module.exports = __webpack_public_path__ + "media/images/arrow-left-976431b172e8fb331bcf8edd744173ae.svg";